import * as tslib_1 from "tslib";
import { Base } from '../base-component';
import './finance-calculator-modals.component.scss';
import * as $ from 'jquery';
var FinanceCalculatorModals = /** @class */ (function (_super) {
    tslib_1.__extends(FinanceCalculatorModals, _super);
    function FinanceCalculatorModals(element, analyticsService) {
        var _this = _super.call(this, element) || this;
        _this.event.register('openModal', _this, _this.openModal.bind(_this));
        return _this;
    }
    FinanceCalculatorModals.prototype.init = function () {
        this.modals = Array.from(this.element.querySelectorAll('.js-calculator-modal'));
        this.modalLinks = Array.from(document.querySelectorAll('.js-calculator-modal-open'));
        this.closeButton = this.element.querySelector('.js-calculator-modal-close');
        this.calculatorReset = Array.from(this.element.querySelectorAll('.js-calculator-reset'));
        this.calculatorSubmit = Array.from(this.element.querySelectorAll('.js-calculator-calculate'));
        this.calculator = this.element.querySelector('form');
        if (this.calculator) {
            this.calculatorFields = Array.from(this.calculator.querySelectorAll('input'));
        }
        this.calculatorOutput = Array.from(document.querySelectorAll('.finance-calculator-modals__total'));
        this.calculatorUseExpenses = Array.from(this.element.querySelectorAll('.js-calculator-use-expenses'));
    };
    FinanceCalculatorModals.prototype.bindEvents = function () {
        var _this = this;
        var totalExpenses = 0;
        this.modals.map(function (item) { return item.addEventListener('click', function (event) {
            _this.isClickOutsideModal(event);
        }); });
        this.modalLinks.map(function (item) { return item.addEventListener('click', function (event) {
            _this.openModals(event);
        }); });
        this.calculatorSubmit.map(function (item) { return item.addEventListener('click', function (event) {
            var service = _this.calculatorService;
            totalExpenses = 0;
            _this.calculatorFields.map(function (itemField) {
                if (itemField.value === null || itemField.value === undefined || itemField.value === '') {
                    totalExpenses += 0;
                }
                else {
                    totalExpenses += parseFloat(itemField.value);
                }
            });
            [].slice.call(_this.calculatorOutput).forEach(function (div) {
                div.innerHTML = service.formatter(totalExpenses);
            });
            // Trigger form Complete when the user calculates the results
            _this.analyticsService.dtmFormComplete("complete", "");
        }); });
        this.calculatorUseExpenses.map(function (item) { return item.addEventListener('click', function (event) {
            event.preventDefault();
            var fieldExpense = Array.from(document.querySelectorAll('input[name=monthly_expenses]'));
            fieldExpense.map(function (item) {
                item.value = totalExpenses;
            });
            _this.closeModal();
        }); });
        if (this.closeButton) {
            this.closeButton.addEventListener('click', function (event) { return _this.closeModal(); });
        }
        this.calculatorReset.map(function (item) { return item.addEventListener('click', function (event) {
            _this.resetInputs(event);
        }); });
    };
    FinanceCalculatorModals.prototype.isClickOutsideModal = function (event) {
        if (event.target === this.activeModal) {
            this.closeModal();
        }
    };
    FinanceCalculatorModals.prototype.openModals = function (event) {
        var element = event.target;
        var modalId = element.getAttribute('data-modal');
        if (modalId === undefined || modalId === '' || modalId === null) {
            var parentElement = $(element).closest('.js-calculator-modal-open');
            modalId = parentElement.attr('data-modal');
        }
        this.activeModal = this.getModalById(modalId);
        this.openModal();
    };
    FinanceCalculatorModals.prototype.closeModal = function () {
        var _this = this;
        this.activeModal.classList.add('modal--close');
        setTimeout(function () {
            _this.activeModal.classList.add('modal--closed');
        }, 250);
    };
    FinanceCalculatorModals.prototype.openModal = function () {
        this.activeModal.classList.remove('modal--close');
        this.activeModal.classList.remove('modal--closed');
    };
    FinanceCalculatorModals.prototype.getModalById = function (id) {
        return this.element.querySelector("#" + id);
    };
    FinanceCalculatorModals.prototype.resetInputs = function (event) {
        event.preventDefault();
        this.calculator.reset();
        [].slice.call(this.calculatorOutput).forEach(function (div) {
            div.innerHTML = '0';
        });
        //Analytics - allow user to trigger a new form start on next interaction
        this.analyticsService.dtmRestartForm();
    };
    return FinanceCalculatorModals;
}(Base));
export { FinanceCalculatorModals };



//////////////////
// WEBPACK FOOTER
// ./components/finance-calculator-modals/finance-calculator-modals.component.ts
// module id = 1041
// module chunks = 0